import { useContext } from "react";
import { AuthContext } from "store/auth/authContext";

export const useAuth = () => useContext(AuthContext);
